export default class Colaborador {

  constructor(
    IdColaborador = null,
    Descricao = '',
    Status = 'A',
    IdTipoColaborador,
    TipoColaborador,
    TipoPessoa = 'F',
    CpfCnpj,
    RgIe,
    Endereco,
    Numero,
    Complemento,
    PontoReferencia,
    IdBairro,
    Bairro,
    IdCidade,
    Cidade,
    Cep,
    Telefone,
    Email,
    DataNascimento,
    IdEquipe,
    Equipe
  ) {
    this.IdColaborador = IdColaborador;
    this.Descricao = Descricao;
    this.Status = Status;
    this.IdTipoColaborador = IdTipoColaborador;
    this.TipoColaborador = TipoColaborador;
    this.TipoPessoa = TipoPessoa;
    this.CpfCnpj = CpfCnpj;
    this.RgIe = RgIe;
    this.Endereco = Endereco;
    this.Numero = Numero;
    this.Complemento = Complemento;
    this.PontoReferencia = PontoReferencia;
    this.IdBairro = IdBairro;
    this.Bairro = Bairro;
    this.IdCidade = IdCidade;
    this.Cidade = Cidade;
    this.Cep = Cep;
    this.Telefone = Telefone;
    this.Email = Email;
    this.DataNascimento = DataNascimento;
    this.IdEquipe = IdEquipe;
    this.Equipe = Equipe;
  }
  
}